import styled from 'styled-components'
import { PRIMARY_COLOR } from '../../../styles/colors.style'

export const StyledSectionHeader = styled.div`
	font-size: 3.2rem;
	color: ${PRIMARY_COLOR};
	border-bottom: 1px solid ${PRIMARY_COLOR};
	padding-bottom: 1rem;
	margin-top: 2rem;
	margin-bottom: 2rem;
	display: flex;
	justify-content: space-between;
`

export default StyledSectionHeader
